import AbstractDataAttributeBehaviour from './abstract-data-attribute-behaviour';
import APIManager from '../services/api-manager';

export default class PartialBehaviour extends AbstractDataAttributeBehaviour {

    APIManager = new APIManager();
    LOADING_BAR_ID = 'partial-loading-bar';

    getContainerSelector() { return '[data-partial]'; }

    /**
     * @param inputElement <HTMLElement>
     * @param eventsOnly <Bool>
     */
    initContainer(inputElement, eventsOnly = false)
    {
        //Handle elements on click
        if (inputElement.getAttribute('data-partial-event') === 'onClick') {
            inputElement.addEventListener('click', (e) => {
                if (!inputElement.getAttribute('loading')) {
                    this.renderPartial(inputElement);
                }
            });

            return;
        }

        //Default handle immediately
        if (!eventsOnly) {
            this.renderPartial(inputElement);
        }
    }

    createLoadingBar(loadingMessage)
    {
        let loadingBar = document.getElementById(this.LOADING_BAR_ID);

        if( !loadingBar ) {
            loadingBar = document.createElement('div');
            loadingBar.classList.add('loading-bar');
            loadingBar.id = this.LOADING_BAR_ID;
            loadingBar.innerText = loadingMessage;


            let stickyNav = document.querySelector('[data-sticky-nav-container]');
            if(stickyNav) {
                loadingBar.classList.add('relative');
                stickyNav.append(loadingBar);
            } else {
                document.body.append(loadingBar);
            }

        }
    }

    removerLoadingBar()
    {
        let loadingBar = document.getElementById(this.LOADING_BAR_ID);
        if(loadingBar) loadingBar.remove();
    }

    /**
     * @param inputElement <HTMLElement>
     * @param callback <Function>
     */
    renderPartial(inputElement, callback = () => {})
    {
        let partialUrl = inputElement.getAttribute('data-partial');
        let containerSelector = inputElement.getAttribute('data-partial-container');
        let containerElement = containerSelector ? document.querySelector(containerSelector) : inputElement;

        let selectedTabId = null;
        let selectedTab = containerElement.querySelector('input[name="price-tab-input"]:checked');
        if(selectedTab) selectedTabId = selectedTab.id;

        inputElement.setAttribute('loading-partial', containerSelector);
        inputElement.classList.add('loading-partial');
        containerElement.classList.add('loading-partial');

        let loadingMessage = inputElement.getAttribute('data-partial-loading-message');
        if(loadingMessage) this.createLoadingBar(loadingMessage);

        this.APIManager.getPartial(partialUrl, (html) => {

            containerElement.innerHTML = html;
            this.reInit(containerElement);
            this.reInitBehaviours();

            //for details page price tabs to keep selection
            if(selectedTabId && containerElement.querySelector('#'+selectedTabId)){
                containerElement.querySelector('#'+selectedTabId).setAttribute('checked', true);
            } else if(containerElement.querySelector('input.price-tab-input')) {
                containerElement.querySelector('input.price-tab-input').setAttribute('checked', true);
            }

            inputElement.removeAttribute('loading-partial');
            inputElement.classList.remove('loading-partial');
            containerElement.classList.remove('loading-partial');
            if(loadingMessage) this.removerLoadingBar();
        }, () => {
            inputElement.removeAttribute('loading-partial');
            inputElement.classList.remove('loading-partial');
            containerElement.classList.remove('loading-partial');
            if(loadingMessage) this.removerLoadingBar();
        }, false);
    }

    reInitBehaviours() {
        for (let behaviour in window.dataAttrBehaviours) {
            window.dataAttrBehaviours[behaviour].init()
        }
    }

    reInit(containerElement)
    {
        let self = this;
        let containers = containerElement.querySelectorAll(this.getContainerSelector());

        for (let i = 0; i < containers.length; i++) {
            let container = containers[i];

            if (self.isContainerInitialised(container)) return;
            self.setContainerInitialised(container);
            self.initContainer(container, true);
        }
    }
}
